import { Button } from 'react-bootstrap';
import { Search, X } from 'lucide-react';
import { Input } from '../../../../components/ui/input';

interface SearchFieldSelectProps {
  value: string;
  onValueChange: (value: string) => void;
  onSubmit: () => void;
  onClear: () => void;
  placeholder?: string;
  width?: string;
}

export function SearchFieldSelect({
  value,
  onValueChange,
  onSubmit,
  onClear,
  placeholder = 'Search orders...',
  width = '240px',
}: SearchFieldSelectProps) {
  return (
    <div className="d-flex align-items-center gap-1">
      <Input
        placeholder={placeholder}
        value={value}
        onChange={(e) => onValueChange(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
            onSubmit();
          }
        }}
        style={{ width, height: '38px' }}
      />

      <Button
        variant="outline-dark"
        size="sm"
        className="bg-gray-50 hover:bg-gray-100 d-flex align-items-center"
        onClick={onSubmit}
        title="Search"
      >
        <Search className="h-4 w-4" />
      </Button>

      {value && (
        <Button
          variant="outline-secondary"
          size="sm"
          className="d-flex align-items-center"
          onClick={onClear}
          title="Clear search"
        >
          <X className="h-4 w-4" />
        </Button>
      )}
    </div>
  );
}
